export default "__VITE_ASSET__CKA4v6Jf__"